import { useLanderConfig } from "../commons/ConfigContext";
import { ExperimentIds } from "../commons/constants/experiment";
import { System } from "../commons/Constants";
import { FeedType } from "../types/LanderConfig";
import { isControlCohort } from "./helper";

export function useYahooModernExperiment() {
  const { landerConfig } = useLanderConfig();
  const { experiment: { key, cohort } = {} } = landerConfig;

  const inExperiment = key === ExperimentIds.yahooModernLander;
  const inTreatmentCohort = !!(
    inExperiment &&
    cohort &&
    !isControlCohort(cohort)
  );
  const isNotParkWeb = landerConfig.system !== System.PARKWEB;
  const isYahooFeed = landerConfig.lander?.feedID === FeedType.YAHOO;
  const isEligible = inExperiment && isNotParkWeb && isYahooFeed;
  const showModernLayout = isEligible && inTreatmentCohort;

  return { showModernLayout, isEligible };
}
